import React, { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";
import { CampaignRequest } from "../../../../../apis/campaign/CampaignRequest";
import { cancel } from "../../../../../assets/icons";
import SmallButton from "../../../../../components/button/SmallButton";
import ErrorHandler from "../../../../../components/toast/ErrorHandler";
import { ActionType } from "../../../../../store/campaign/action";
import CampaignContext from "../../../../../store/campaign/CampaignContext";

const DeleteProductcampaignModal = () => {
  const { CampaignDispatch, CampaignState } = useContext(CampaignContext);
  const { showDeleteCampaign } = CampaignState;

  const goBack = () => {
    CampaignDispatch({
      type: ActionType.ShowDeleteCampaign,
      payload: {
        id: 0,
        status: false,
      },
    });
  };

  const DeleteProductcampaign = async () => {
    await mutation.mutate();
  };

  const queryClient = useQueryClient();
  const mutation = useMutation(
    () => CampaignRequest.deleteCampaignProductTemplate(showDeleteCampaign.id),
    {
      onSettled: async (data: any, error: any) => {
        if (error) {
          console.log(error);
        } else if (data === 200) {
          await queryClient.invalidateQueries("GetCampaignTemplate");
          ErrorHandler("#00C62E", "Delete Completed");
          goBack();
        }
      },
    }
  );

  return (
    <div className="fixed z-50 h-screen inset-0 flex justify-center md:items-center items-start bg-black bg-opacity-70">
      <div className="bg-white w-1/4 h-auto rounded-xl my-auto mx-auto font-med">
        <div className="flex w-full justify-end items-center px-8 pb-5 pt-8">
          <img
            src={cancel}
            alt="cancel"
            className="cursor-pointer w-5"
            onClick={goBack}
          />
        </div>
        <div className="px-10 pb-3">
          <div className="flex flex-col items-center">
            <h1 className="text-xl">Delete Campaign Product</h1>
            <h1 className="text-base text-center w-60 text-textPrimary mt-4 font-rom">
              Are you sure you want to delete the Campaign Product ?
            </h1>
          </div>

          <div className="flex justify-center my-8 outline-none">
            <SmallButton
              loadColor={"white"}
              type={"button"}
              handleClick={goBack}
              color={"bg-white"}
              border={"border-2"}
              borderColor={"border-breadscrumbColor"}
              hoverColor={"opacity-70"}
              text={"Cancel"}
              textColor={"text-textPrimary"}
              height={10}
            />
            <div className="mx-1.5"></div>
            <SmallButton
              isSubmitting={mutation.isLoading}
              loadColor={"white"}
              type={"button"}
              height={10}
              handleClick={DeleteProductcampaign}
              color={"bg-primary"}
              hoverColor={"bg-red-300"}
              text={"Delete"}
              textColor={"text-white"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteProductcampaignModal;
